import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    font-size: 16px;
    font-family: 'Open Sans', sans-serif;
    -webkit-user-select: none; /* Safari */        
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard */

    a {
      text-decoration: none;
      color: inherit;
    }
  }

  body {
    scroll-behavior: smooth;
    margin: 0;
    padding: 0;
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
  }

  #app {
    overflow: auto;
  }

  #toast {
    z-index: 3500;
    position: fixed;
    top: 40px;
    right: 0;
    padding: 4px;
    width: 320px;

    ${props => props.theme.media.phone`
      width: 100%;
    `}
  }
`;

export default GlobalStyle;
